import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sparkle",
  "use": "icon-sparkle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sparkle\">\n<path d=\"M8.14328 2.28571C8.70328 5.64571 10.6404 7.58285 14.0004 8.14285C10.6404 8.70285 8.70328 10.64 8.14328 14C7.58328 10.64 5.64613 8.70285 2.28613 8.14285C5.64613 7.58285 7.58328 5.64571 8.14328 2.28571Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol